import FormControl from "common/components/FormControl/FormControl";
import FormScrollError from "common/components/FormScrollError/FormScrollError";
import { useMemo, useState } from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import arrayMutators from "final-form-arrays";
import EditHeader from "common/components/EditHeader/EditHeader";
import useRouter from "common/hooks/use-router";
import HeaderButtonsEdit from "common/components/EditHeader/HeaderButtonsEdit";
import imgSizes from "conf/imgSizes.json";
import useOrganization from "common/hooks/useOrganization";

function UserTypeForm({ onSubmit, userType }: any) {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const [errorMessage, setErrorMessage] = useState("");
  const { organization: currentOrganization } = useOrganization();

  const initialValues = useMemo(
    () =>
      userType?.id
        ? {
            ...userType,
          }
        : {
            name: "",
            icon: null,
            organization: currentOrganization?.id,
          },
    [currentOrganization?.id, userType]
  );

  const onSubmitWrapper = async (values: any) => {
    const res = await onSubmit(values);

    if (res.message) {
      setErrorMessage(res.message);
    }
  };

  return (
    <Form
      onSubmit={onSubmitWrapper}
      mutators={{
        ...arrayMutators,
        setFieldValue: ([field]: any, state: any, utils: any) => {
          utils.changeValue(state, field.field, () => field.value);
        },
      }}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({ handleSubmit, values }) => {
        return (
          <div className="mx-auto max-w-full py-4 px-4 text-slate-500 text-base">
            {/* Header */}
            <EditHeader
              title={t(userType?.id ? "editItem.userType" : "newItem.userType")}
              subtitle={values.name}
              icon="UserCircleIcon"
              errorMessage={errorMessage}
              HeaderButtonsEdit={
                <HeaderButtonsEdit
                  inHeader
                  onSubmit={handleSubmit}
                  onCancel={() => navigate("/user-types")}
                />
              }
            />
            <form onSubmit={handleSubmit} noValidate>
              <FormScrollError />

              <div className="responsive-flex gap-2 mt-2">
                <div className="md:w-full mb-2 md:mb-0">
                  <div className="flex flex-col gap-2 w-full">
                    <div className="white-box">
                      <div className="responsive-flex gap-4">
                        <div className="flex flex-col w-full md:w-[180px]">
                          <FormControl
                            title={t("forms.icon")}
                            labelIcon="PhotoIcon"
                            name="icon"
                            type="image"
                            maxWidth={imgSizes.icon.width}
                            maxHeight={imgSizes.icon.height}
                          />
                        </div>
                        <div className="flex flex-col w-full">
                          <FormControl
                            name="name"
                            titleKey={t("forms.name")}
                            required
                            containerStyle="flex w-full mb-4"
                            className="text-input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HeaderButtonsEdit
                onSubmit={handleSubmit}
                onCancel={() => navigate("/user-types")}
              />
            </form>
          </div>
        );
      }}
    />
  );
}
export default UserTypeForm;
